<template>
  <div class="category-list">
    <el-card style="min-height: 640px">
      <el-row class="mb-16" type="flex">
        <el-col :span="12">
          <el-button
            @click="handlerAddCateGory"
            icon="el-icon-plus"
            type="primary"
            v-auth="'stores::product-manager::cate-add'"
          >
            {{ $t('product-manager::category::add_button') }}
          </el-button>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <span>{{ $t('product-manager::category::search') }}：</span>
          <el-input
            :placeholder="$t('product-manager::category::placeholder_search')"
            @keyup.enter.native="init"
            class="search-input"
            prefix-icon="el-icon-search"
            v-model.trim="params.categoryName"
          ></el-input>
        </el-col>
      </el-row>
      <z-table
        :columns="columns"
        :customDefault="{
          desc: $t('system::common::tips::quick_setting'),
          buttons: [
            {
              btnClick: initCategory,
              text: $t('product-manager::init_cate'),
              type: 'text'
            }
          ]
        }"
        :data="tableData"
        :pagination.sync="pagination"
        :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
        @expand-change="handleExpandChange"
        @page-change="getListData"
        height="540px"
        row-key="id"
        ref="table"
        v-loading="loading"
      >
        <el-table-column
          :label="$t('product-manager::category::table_name')"
          prop="name"
          sortable
          width="180"
        ></el-table-column>
        <template #control="{ row }">
          <el-button
            @click="handleControl(row, 'edit')"
            class="btn-item"
            type="text"
            v-auth="'stores::product-manager::cate-edit'"
          >
            {{ $t('product-manager::category::table_edit') }}
          </el-button>
          <el-button
            @click="handleControl(row, 'next')"
            class="btn-item"
            type="text"
            v-auth="'stores::product-manager::cate-edit'"
            v-if="row.level < 4"
          >
            {{ $t('product-manager::category::table_add') }}
          </el-button>
          <el-button
            @click="handleControl(row, 'delete')"
            class="btn-item"
            style="color: red"
            type="text"
            v-auth="'stores::product-manager::cate-delete'"
            v-if="!row.productCount && row.childrens.length === 0"
          >
            {{ $t('product-manager::category::table_delete') }}
          </el-button>
        </template>
      </z-table>
    </el-card>
    <cateModal :cateData="cateInfoData" :visible.sync="modal" @save="handleSave"></cateModal>
  </div>
</template>

<script>
import { getList, deleteListItem, putListItem, initCate } from '@/server/category.js'
import cateModal from './category-modal'
import { STATUS_OPTION } from '@/config'
export default {
  name: 'cateList',
  components: {
    cateModal
  },
  computed: {
    statusObject() {
      const obj = {}
      this.statusOptions.forEach(item => {
        obj[item.value] = item.label
      })
      return obj
    }
  },
  data() {
    return {
      defaultImage: require('@/assets/images/image-placeholder.png'),
      params: {
        categoryName: ''
      },
      cateInfoData: null,
      statusOptions: STATUS_OPTION,
      columns: [
        {
          prop: 'name',
          label: this.$t('product-manager::category::table_name')
        },
        {
          prop: 'control',
          label: this.$t('product-manager::category::table_handle'),
          width: '220',
          fixed: 'right'
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0
      },
      loading: false,
      modal: false,
      searchConfigs: [
        {
          key: 'categoryName',
          searchType: 'input',
          label: '商品类目'
        }
      ]
    }
  },
  async mounted() {
    this.init()
  },
  watch: {
    $route() {
      if (this.$route.query.update === 'edit') {
        this.getListData()
      } else if (this.$route.query.update === 'add') {
        this.getListData(true)
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf('/tyingSale-add') === 0) {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  },
  methods: {
    init(bool = true, fn) {
      this.getListData(bool, fn)
    },
    handlerAddCateGory() {
      this.cateInfoData = {
        name: '',
        type: 'add',
        row: null,
        category: [],
        color: ''
      }
      this.modal = true
    },
    // 取级展开逻辑
    expendRow(obj) {
      const fn = (arr, data) => {
        arr.forEach(item => {
          if (data.findIndex(fid => fid.id === item) >= 0) {
            const index = data.findIndex(fid => fid.id === item)
            // 手动展开
            this.$refs.table.$children[0].toggleRowExpansion(data[index], true)
            setTimeout(() => {
              this.$refs.table.$children[0].toggleRowExpansion(data[index], true)
            })
            if (data[index] && data[index].childrens) {
              fn(arr, data[index].childrens)
            }
          }
        })
      }
      fn(obj.category, this.tableData)
    },
    handlerEditCateGory(data) {
      this.cateInfoData = {
        ...data
      }

      this.modal = true
    },
    handleSave(obj) {
      // 新建类目操作
      console.log(obj, '查看数据')
      this.init(true, () => this.expendRow(obj))
    },
    handlerExpand() {
      console.log(this.$refs.table.toggleRowExpansion)
    },
    handleExpandChange(row, expand) {
      console.log(row, expand, this.$refs.table.$children[0])
    },

    async initCategory() {
      const { data } = await initCate({
        code: 'product_category'
      })
      if (data.code === this.$code) {
        this.$message.success($t('system::tip::control_success'))
        this.getListData()
      }
    },

    async getListData(init = false, fn) {
      // setTimeout(() => {
      //   this.$refs.table.$children[0].toggleRowExpansion(this.tableData[2], true)
      // }, 1000)
      if (init) {
        // 回到第一页
        this.pagination.pageNum = 1
      }
      this.loading = true
      const { data } = await getList({
        ...this.params,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize
      })
      this.loading = false
      if (data.code === this.$code) {
        this.tableData = data.data.items.map((item, i) => {
          return {
            ...item,
            index: this.pagination.pageSize * (this.pagination.pageNum - 1) + i + 1
          }
        })
        this.pagination.total = data.data.totalCount ? data.data.totalCount : 0
        if (fn) fn()
      }
    },
    showOplog(row) {
      this.$refs.log.show(row.userId)
    },
    showCustomers(row) {
      this.$refs.customers.show(row.userId)
    },
    handleControl(row, type) {
      const that = this
      // 查找对应的父级树
      const fAr = (arr, tarr = []) => {
        arr.forEach(item => {
          if (item.childrens.length) {
            tarr = tarr.concat(fAr(item.childrens))
          }
        })
        return tarr.concat(arr)
      }
      let arrAll = fAr(this.tableData)
      const fmd = (item, arr) => {
        if (item.level === 0) {
          return item
        } else {
          return fmd(
            arrAll.find(im => im.id === item.parentId),
            arr
          )
        }
      }
      console.log(fmd(row, arrAll), '目标父级', row)
      const rowParent = fmd(row, arrAll) || {}
      const cates = row.category.split('-').map(i => Number(i))
      switch (type) {
        case 'edit':
          this.handlerEditCateGory({
            id: row.id,
            name: row.name,
            parentId: row.parentId,
            category: row.childrens.length ? cates : cates.slice(0, cates.length - 1),
            row,
            type
          })
          break
        case 'next':
          this.handlerEditCateGory({
            id: row.id,
            name: '',
            parentId: row.parentId,
            category: cates,
            type,
            row,
            rowParent
          })
          break
        case 'delete':
          this.$confirm(
            `<p>${this.$t('product-manager::category::form_name')}： ${row.name}</p><p>${this.$t(
              'product-manager::category::delete_tip'
            )}</p>`,
            this.$t('product-manager::category::delete_title'),
            {
              confirmButtonText: this.$t('system::common::btn::confirm'),
              dangerouslyUseHTMLString: true,
              cancelButtonText: this.$t('system::common::btn::cancel'),
              beforeClose: async (action, instance, done) => {
                if (action === 'confirm') {
                  instance.confirmButtonLoading = true
                  let { data } = await deleteListItem({ id: row.id })
                  if (that.$code === data.code) {
                    that.$message.success(that.$t('system::tip::delete_success'))
                    instance.confirmButtonLoading = false
                    done()
                    that.getListData()
                  } else {
                    that.$message.error(data.msg)
                  }
                } else {
                  done()
                }
              }
            }
          )
            // .then(async () => {
            //   let {data} = await deleteListItem({id: row.id})
            //   if (this.$code === data.code) {
            //     this.$message.success('this.$t('system::tip::delete_success'))
            //     this.getListData()
            //   }
            // })
            .catch(() => {})
          break
      }
    },
    searchReset() {
      this.params = {
        categoryName: ''
      }
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.category-list {
  /deep/ .cell {
    color: #666;
  }
  .search-input {
    width: 180px;
  }
  .right-box {
    text-align: right;
  }
  .card-box {
    margin-top: 16px;
  }
}
</style>
